/**
 * DOM constants per the WHATWG DOM spec.
 *
 * The `Node` and `NodeFilter` globals only exist in browsers. During SSR the HTML parser
 * plugins run on jsdom documents in the Nitro runtime, where referencing those globals
 * throws a ReferenceError (and crashes the whole page render with a 500), so plugin code
 * must use these numeric values instead.
 */
export const ELEMENT_NODE = 1
export const TEXT_NODE = 3
export const SHOW_TEXT = 0x4
